import { CheckCircle2, Circle, Clock } from "lucide-react";

const steps = [
  ["confirmed_at", "Confirmed"],
  ["preparation_started_at", "Preparing"],
  ["ready_at", "Ready"],
  ["out_for_delivery_at", "Out"],
  ["delivered_at", "Delivered"],
];

export default function OrderProgressTracker({ order }) {
  return (
    <section className="order-panel order-progress-panel">
      <header><h2>Progress</h2></header>
      <div className="order-progress-track">
        {steps.map(([field, label], index) => {
          const complete = Boolean(order?.[field]);
          const Icon = complete ? CheckCircle2 : index === 0 ? Clock : Circle;
          return (
            <div className={complete ? "order-progress-step order-progress-step--complete" : "order-progress-step"} key={field}>
              <span><Icon size={18} /></span>
              <strong>{label}</strong>
              <small>{complete ? new Date(order[field]).toLocaleString() : "Waiting"}</small>
            </div>
          );
        })}
      </div>
    </section>
  );
}
